import BackToTop from "./components/back-to-top";

const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};


/**
 * Handles the opening/closing of the off-canvas menu
 * @param body HTML body element
 */
const initOffCanvas = (body) => {

	const toggleButton  = document.querySelector('.toggle-off-canvas');
	const offCanvas = document.querySelector('.off-canvas');

	if (!toggleButton) {
		console.error(`Failed to initialize off canvas menu. Missing toggle button '.toggle-off-canvas'`);
		return;
	}

	if (!offCanvas) {
		console.error(`Failed to initialize off canvas menu. Missing off canvas menu '.offCanvas'`);
		return;
	}

	toggleButton.addEventListener( 'click', () => {
		const _offCanvas = document.querySelector('.off-canvas');
		_offCanvas.classList.toggle('hidden');
		toggleButton.classList.toggle('open');
	})
}

const openAccordion = (content,svg) => {
	content.style.maxHeight = (12000 + 150) + 'px';
	content.style.paddingBottom = '1.5rem';
	content.style.paddingTop = '1.5rem';
	svg.style.transform = 'rotate(45deg)';
}

const closeAccordion = (content,svg) => {
	content.style.maxHeight = '0px';
	content.style.paddingBottom = '0px';
	content.style.paddingTop = '0px';
	svg.style.transform = 'rotate(0deg)';
}

const toggleAccordion = (e) => {
	const accordionContent = e.target.nextElementSibling;
	const accordionMaxHeight = accordionContent.style.maxHeight;
	const target = e.target;
	const accordionSVG = target.querySelector('svg');
	// console.log(accordionSVG)
	if (accordionMaxHeight === "0px" || accordionMaxHeight.length === 0) {
		openAccordion(accordionContent, accordionSVG);
	} else {
		closeAccordion(accordionContent, accordionSVG);
	}
}

const initAjaxLoadMore = (body) => {

	const loadMoreButton = body.querySelector('#ajax-load-more');

	if (!loadMoreButton)
		return;

	loadMoreButton.addEventListener('click', async (e) => {

		e.preventDefault();

		if ( e.target.dataset.loading === 'true' )
			return;

		const label = e.target.querySelector('.label');
		const loader = e.target.querySelector('.loader');

		const postType = e.target.dataset.type;
		const taxonomy = e.target.dataset.taxonomy;
		const limit = e.target.dataset.limit;
		const page = e.target.dataset.page;
		const targetElement = document.querySelector(e.target.dataset.target);

		const action = e.target.dataset.action;
		const ajaxURL = THEME_OBJ.ajaxURL;
		const nonce = e.target.dataset.nonce;

		const categories = e.target.dataset.categories;

		const data = new FormData();
		data.append( 'action', action );
		data.append( 'nonce', nonce );
		data.append( 'page', page);
		data.append( 'limit', limit);
		data.append( 'post_type', postType);
		data.append( 'taxonomy', taxonomy);
		data.append( 'categories', categories);

		label.classList.add('hidden');
		loader.classList.remove('hidden');
		e.target.dataset.loading = 'true';

		const ajaxCall = await fetch(ajaxURL, {
			method: 'POST',
			body: data
		}).then((res) => res.json())
			.then((data) => {
				targetElement.innerHTML += data.html;
				if (data.is_last) {
					e.target.classList.add("!hidden");
				}
				else {
					e.target.setAttribute("data-page", parseInt(page)+1);
				}
				label.classList.remove('hidden');
				loader.classList.add('hidden');
				e.target.dataset.loading = 'false';
			})
			.catch((err) => {
				console.log(err);
				label.classList.remove('hidden');
				loader.classList.add('hidden');
				e.target.dataset.loading = 'false';
			});
	})

}

const initFilters = (body) => {

	const ajaxFilters = body.querySelectorAll('.ajax-filter');
	const filterButton = body.querySelector('.ajax-filter-button');
	const filterButtonLink = body.querySelector('.ajax-filter-button-link');
	let hasSelectedFilter = false;

	if (ajaxFilters) {
		ajaxFilters.forEach( (filter) => {
			console.log('filter.dataset.active')
			console.log(filter.dataset.active)
			if (filter.dataset.active === 'true') {
				hasSelectedFilter = true;
			}

			filter.addEventListener('click', (e) => {

				e.preventDefault();

				const _this = e.target;

				if (_this.dataset.active === "false") {
					_this.dataset.active = 'true';
					_this.classList.add('filter-active');
				}
				else {
					_this.dataset.active = 'false';
					_this.classList.remove('filter-active');
				}

			})

		})

		if (hasSelectedFilter) {
			if (filterButton) {
				setTimeout(() => {
					filterButton.click();
				}, 800)
			}
		}
	}

	if (filterButton) {
		filterButton.addEventListener('click', async (e) => {

			e.preventDefault();

			if (e.target.dataset.loading === 'true')
				return;

			const selectedFilters = body.querySelectorAll('.ajax-filter[data-active="true"]');
			const loadMoreButton = body.querySelector('#ajax-load-more');

			const svgLoader = body.querySelector('.loader-svg');

			const categoriesArray = [];

			selectedFilters.forEach ((filter) => {
				categoriesArray.push(filter.dataset.category);
			})

			const categories = categoriesArray.join(',');

			const postType = e.target.dataset.type;
			const taxonomy = e.target.dataset.taxonomy;
			const limit = e.target.dataset.limit;
			const page = e.target.dataset.page;
			const targetElement = document.querySelector(e.target.dataset.target);

			const action = e.target.dataset.action;
			const ajaxURL = THEME_OBJ.ajaxURL;
			const nonce = e.target.dataset.nonce;

			targetElement.innerHTML = svgLoader.innerHTML;

			const data = new FormData();
			data.append( 'action', 'load-more-blog-posts' );
			data.append( 'nonce', nonce );
			data.append( 'page', '1');
			data.append( 'limit', limit);
			data.append( 'post_type', postType);
			data.append( 'taxonomy', taxonomy);
			data.append( 'categories', categories);

			if (loadMoreButton) {
				loadMoreButton.dataset.page = '2';
				loadMoreButton.dataset.categories = categories;
				loadMoreButton.classList.add("!hidden");
			}

			e.target.dataset.loading = 'true';

			const ajaxCall = await fetch(ajaxURL, {
				method: 'POST',
				body: data
			}).then((res) => res.json())
				.then((data) => {
					console.log(data)
					targetElement.innerHTML = data.html;
					if (data.is_last) {
						loadMoreButton.classList.add("!hidden");
					}
					else {
						loadMoreButton.classList.remove('!hidden');
					}
					e.target.dataset.loading = 'false';
				})
				.catch((err) => {
					console.log(err);
					e.target.dataset.loading = 'false';
				});

		})
		console.log('Filters applied - Button')

	}

	if (filterButtonLink) {
		filterButtonLink.addEventListener('click', async (e) => {

			e.preventDefault();

			if (e.target.dataset.loading === 'true')
				return;

			const selectedFilters = body.querySelectorAll('.ajax-filter[data-active="true"]');

			const categoriesArray = [];

			selectedFilters.forEach ((filter) => {
				categoriesArray.push(filter.dataset.category);
			})

			const categories = categoriesArray.join(',');

			window.location.href = `${e.target.dataset.link}/?categories=${categories}`;

		})
	}

}

const initSwiper = (body) => {
	const swipers = Array.from(body.querySelectorAll('.swiper'));

	if (!swipers || swipers.length === 0 || 'undefined' === typeof Swiper) return;

	for (let i = 0; i < swipers.length; i++) {

		const swiper = new Swiper(swipers[i], {
			slidesPerView: 'auto',
			// loop: true,
			spaceBetween: 20,
			navigation: {
				nextEl: swipers[i].querySelector('.swiper-button.next'),
				prevEl: swipers[i].querySelector('.swiper-button.prev'),
			},
			breakpoints: {
				768: {
					// slidesPerView: 3,
					spaceBetween: 40,
				}
			}
		});
	}
}

const initHeroVideo = () => {
	const videos = Array.from(document.querySelectorAll('.hero-video'));
	if (videos.length > 0) {
		videos.forEach((video) => {
		video.addEventListener('ended', () => {
			setTimeout(() => {
				video.currentTime = 0;
				video.play();
			}, HERO_VIDEO.videoDelay ?? 0);
		});

		video.play();

		});
	}
}

const App = {
	init() {
		const body = document.body;
		const accordions = document.querySelectorAll('.accordion-header');
		let resizeTimeout = null;

		accordions.forEach((accordion) => {
			accordion.addEventListener('click', toggleAccordion);
		})

		window.addEventListener('resize', () => {
			if (resizeTimeout) return;
			resizeTimeout = setTimeout(() => {
				if (accordions.length > 0) {
					accordions.forEach((accordion) => {
						accordion.nextElementSibling.style.maxHeight = '1px';
						accordion.dispatchEvent(new Event('click'));
					});
				}
				resizeTimeout = null;
			}, 100);
		});

		// const backToTop = new BackToTop();
		initOffCanvas(body);
		initAjaxLoadMore(body);
		initFilters(body);
		initSwiper(body);
		initHeroVideo();
	},
};

domLoaded(() => {
	App.init();
});
